const carouselItems = [
  {
    id: 1,
    title: '七月新番推荐',
    desc: '精选本季最值得追的日漫新番，从热血战斗到治愈日常，总有一部适合你。',
    image: 'https://readdy.ai/api/search-image?query=Anime%20style%20illustration%20featuring%20vibrant%20summer%20theme%20with%20cherry%20blossom%20petals%20and%20warm%20sunset%20lighting%2C%20multiple%20anime%20characters%20silhouettes%20in%20dynamic%20poses%2C%20soft%20pink%20and%20golden%20gradient%20background%2C%20energetic%20and%20hopeful%20atmosphere%2C%20painterly%20digital%20art%20style%2C%20cinematic%20composition%2C%20high%20detail&width=800&height=500&seq=carousel-01&orientation=landscape',
    tag: '新番速递',
    badge: '🔥 热门',
  },
  {
    id: 2,
    title: '国漫崛起专题',
    desc: '近年国漫精品层出不穷，《凡人修仙传》《完美世界》《斗破苍穹》等佳作辈出。',
    image: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20martial%20arts%20fantasy%20illustration%20with%20traditional%20Chinese%20elements%2C%20floating%20mountains%20and%20ancient%20temples%2C%20warm%20golden%20and%20coral%20color%20palette%2C%20mystical%20atmosphere%20with%20cherry%20blossom%20petals%2C%20cinematic%20lighting%2C%20digital%20art%20style%2C%20grand%20scale%20composition&width=800&height=500&seq=carousel-02&orientation=landscape',
    tag: '国漫精选',
    badge: '⭐ 推荐',
  },
  {
    id: 3,
    title: '剧场版动漫合集',
    desc: '精选高分动漫电影，感受大银幕级别的视听盛宴，一次看过瘾。',
    image: 'https://readdy.ai/api/search-image?query=Beautiful%20anime%20movie%20style%20illustration%20with%20dramatic%20sky%20and%20clouds%2C%20silhouette%20of%20characters%20looking%20at%20distant%20horizon%2C%20warm%20sunset%20colors%20with%20pink%20and%20golden%20hues%2C%20cinematic%20widescreen%20composition%2C%20emotional%20and%20breathtaking%20atmosphere%2C%20painterly%20digital%20art%2C%20cherry%20blossom%20scattered&width=800&height=500&seq=carousel-03&orientation=landscape',
    tag: '剧场版',
    badge: '🎬 热门',
  },
  {
    id: 4,
    title: '异世界冒险特辑',
    desc: '穿越异世界，开启奇幻冒险之旅。从《Re:Zero》到《关于我转生变成史莱姆这档事》，精彩不断。',
    image: 'https://readdy.ai/api/search-image?query=Fantasy%20anime%20illustration%20of%20a%20magical%20world%20with%20floating%20islands%2C%20mystical%20glowing%20portals%2C%20warm%20ethereal%20lighting%2C%20soft%20pink%20and%20golden%20clouds%2C%20adventure%20theme%2C%20Japanese%20anime%20art%20style%2C%20dreamy%20atmosphere%2C%20high%20detail%20digital%20painting&width=800&height=500&seq=carousel-04&orientation=landscape',
    tag: '异世界',
    badge: '🌍 人气',
  },
  {
    id: 5,
    title: '经典老番回顾',
    desc: '重温那些年感动我们的经典动漫，《钢之炼金术师》《CLANNAD》《命运石之门》，满满的回忆。',
    image: 'https://readdy.ai/api/search-image?query=Nostalgic%20anime%20style%20illustration%20with%20warm%20vintage%20film%20aesthetic%2C%20soft%20golden%20light%20rays%2C%20cherry%20blossom%20petals%20drifting%2C%20silhouette%20of%20classic%20anime%20characters%2C%20emotional%20and%20warm%20atmosphere%2C%20film%20grain%20texture%2C%20painterly%20digital%20art%2C%20nostalgic%20color%20palette&width=800&height=500&seq=carousel-05&orientation=landscape',
    tag: '经典回眸',
    badge: '💎 珍藏',
  },
];

export default function Carousel() {
  return (
    <section id="carousel" className="py-14 md:py-20 bg-background-100">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            专题推荐
          </h2>
          <p className="text-sm md:text-base text-foreground-500 max-w-lg mx-auto">
            精心策划的动漫专题，发现更多你可能会喜欢的好作品
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
          {carouselItems.map((item) => (
            <div
              key={item.id}
              className="group bg-background-50 rounded-2xl border border-background-200/60 hover:border-accent-200/60 overflow-hidden transition-all duration-300 cursor-pointer"
            >
              <div className="relative h-48 md:h-52 overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  loading="lazy"
                />
                <div className="absolute top-3 left-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-background-50/90 text-foreground-800 font-medium whitespace-nowrap backdrop-blur-sm">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute top-3 right-3">
                  <span className="text-xs px-2.5 py-1 rounded-full bg-accent-500/90 text-background-50 font-medium whitespace-nowrap backdrop-blur-sm">
                    {item.badge}
                  </span>
                </div>
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base md:text-lg font-heading font-bold text-foreground-900 mb-2">{item.title}</h3>
                <p className="text-sm text-foreground-500 leading-relaxed">{item.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}